/**
 * The violation reports by users regarding
 * bids, marketplace comments, messages, private messages,
 * profiles, and projects.
 */
export interface ViolationReport {
  readonly comments: string;
  readonly content: string;
  readonly id: number;
  readonly objectId: number;
  readonly objectType: ViolationReportObjectType;
  readonly reason: ViolationReportReason;
  readonly url: string;
  readonly userId: number;
  readonly violateUserId: number;
}

export enum ViolationReportObjectType {
  BID = 'bid',
  MARKETPLACE_COMMENT = 'marketplace_comment',
  MESSAGE = 'message',
  PRIVATE_MESSAGE_VIOLATION = 'private_message_violation',
  PROFILE = 'profile',
  PROJECT = 'project',
}

export enum ViolationReportReason {
  ADVERTISING = 'advertising',
  CONTACTS = 'contacts',
  FAKE = 'fake',
  HARASSMENT = 'harassment',
  NONFEATURED = 'nonfeatured',
  OTHER = 'other',
}
